import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useApi } from './ApiContext'; 
import { useAuth } from './AuthContext'; 
import './AutoLogout.css';

const AutoLogout = () => {
    // ➡️ Ambil 'api' daripada ApiContext
    const { api } = useApi();
    const { isAuthenticated, username, setIsAuthenticated, userType, setUsername, setEmail, setUserType } = useAuth(); 
    const history = useHistory();

    const [warningVisible, setWarningVisible] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState(180);

    // Kalau user adalah Admin, terus matikan fungsi AutoLogout
    const isAdmin = userType === 'Admin';

    // ✅ FUNGSI LOGOUT YANG DIKEMASKINI
    const handleLogout = async () => {
        if (!api) return;

        try {
            // Menggunakan 'api.post' (Axios) supaya kuki sesi dihantar dengan betul
            await api.post('/logout');
            
            setIsAuthenticated(false);
            setUsername('');
            setEmail('');
            setUserType('');
            history.push('/');
        } catch (error) {
            console.error('AutoLogout error:', error);
        }
    };

    const resetTimer = () => {
        setTimeRemaining(180);
        setWarningVisible(false);
    };

    useEffect(() => {
        // Kalau bukan authenticated ATAU user adalah Admin, jangan jalankan timer
        if (!isAuthenticated || isAdmin) return;

        const timer = setInterval(() => {
            setTimeRemaining(prevTime => {
                if (prevTime <= 0) {
                    clearInterval(timer);
                    handleLogout();
                    return 0;
                }
                if (prevTime === 60) setWarningVisible(true);
                return prevTime - 1;
            });
        }, 1000);

        const events = ['mousemove', 'keydown', 'click', 'scroll'];
        events.forEach(event => window.addEventListener(event, resetTimer));

        return () => {
            clearInterval(timer);
            events.forEach(event => window.removeEventListener(event, resetTimer));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, isAdmin]); 

    return (
        <>
            {/* Warning cuma akan keluar kalau BUKAN admin */}
            {warningVisible && !isAdmin && (
                <>
                    <div className="overlay"></div>
                    <div className="warning-dialog">
                        <p>Hello {username || 'user'}! You have been inactive. You will be logged out in {timeRemaining} seconds.</p>
                        <p>Click anywhere to continue your session.</p>
                    </div>
                </>
            )}
        </>
    );
};

export default AutoLogout;